import PromiseWorker from 'promise-worker';

const worker = new Worker(new URL('./worker', import.meta.url), {
  type: 'module',
});
export const PARSER_WORKER = new PromiseWorker(worker);

export const terminateWorker = () => {
  worker.terminate();
};
